import { DOMNodeProps } from "@/types";
import { ReactNode } from "react";
import styles from "./Container.module.scss";

export interface ContainerProps extends DOMNodeProps {
  children?: ReactNode;
  title?: ReactNode;
  right?: ReactNode;
  contentClassName?: string;
  loading?: boolean;
  padding?: boolean;
  noRoundedTop?: boolean;
}

export default function Container({
  children,
  title,
  right,
  className,
  contentClassName,
  loading = false,
  padding = true,
  noRoundedTop = false,
  ...props
}: ContainerProps) {
  return (
    <div
      className={[
        styles.Container,
        className,
        padding ? styles["padding"] : styles["no-padding"],
        noRoundedTop ? styles["no-rounded-top"] : "",
      ].join(" ")}
      {...props}
    >
      {(title || right) && (
        <div className={styles.header}>
          <div className={styles.title}>{title}</div>
          <div className={styles.right}>{right}</div>
        </div>
      )}
      <div className={`${styles.content} ${contentClassName}`}>{children}</div>
    </div>
  );
}
